import { Card, CardText, CardActions, FlatButton } from "material-ui";
import { ActionDeleteForever, ImageEdit } from "material-ui/svg-icons";
import Dialog from "material-ui/Dialog";
import {
  deleteEvaluation,
  getReviewingStudentEvaluations,
  getSprints,
  getTeacherAssignments,
  setLoadingAssets,
  setAssignment,
  setSprint,
  setEvaluation,
} from "../../../../redux";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { CardHeader } from "material-ui/Card";
import "./index.css";


const StudentOverview = (props) => {
  const student = props.student;
  const user = props.user;

  const studentEvaluations = props.reviewingEvaluations.filter(
    (evaluation) => evaluation.user === student._id
  );
  const teacherAssignments = props.assignments;
  const assignmentMap = teacherAssignments.reduce((acc, assignment) => {
    acc[assignment._id] = assignment;
    return acc;
  }, {});
  const sprints = props.sprints;
  const sprintMap = sprints.reduce((acc, sprint) => {
    acc[sprint._id] = sprint;
    return acc;
  }, {});

  const navigate = useNavigate();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [evaluationToDelete, setEvaluationToDelete] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (student && user) {
      props.getReviewingStudentEvaluations(student._id);
      props.getTeacherAssignments(user._id);
      props.getSprints(user._id);
    }
  }, [props.getReviewingStudentEvaluations, props.getTeacherAssignments]);

  const handleDeleteEvaluation = (evaluation) => {
    setEvaluationToDelete(evaluation);
    setShowDeleteDialog(true);
  };

  const confirmDelete = () => {
    if (evaluationToDelete) {
      props.deleteEvaluation(evaluationToDelete._id, []);
      setShowDeleteDialog(false);
      setEvaluationToDelete(null);
      setShowSuccessMessage(true);
      props.getReviewingStudentEvaluations(student._id);
    }
  };

  const cancelDelete = () => {
    setShowDeleteDialog(false);
    setEvaluationToDelete(null);
  };

  return (
    <div className="dashboard">
      <div className="">
        <Link to="/manage/students" className="backButton">
          <img src={require("../../../../Images/leftArrow.png")} alt="<-" />
          Return to Manage Students
        </Link>
        {!student ? (
          <div>Student not found</div>
        ) : (
          <div>
            <header>
              <div className="flex-1 flex-row justify-between">
                <div>
                  <b>Student Overview</b>
                  <br />
                  <div>
                    <small>Email: {student.email}</small>
                    <br />
                    <small>Student ID: {student.studentId}</small>
                  </div>
                  <h1>
                    {student.lastName}, {student.firstName}
                  </h1>
                </div>
                <div>
                  <FlatButton
                    icon={<ImageEdit />}
                    onClick={() => navigate(`/student/edit`)}
                    label="Edit Student Information"
                  />
                </div>
              </div>
            </header>
            <hr />
            <div>
              <h2>Assignments (Reviewing Student)</h2>
              <br />
              <div className="flex-row gap-4">
                {studentEvaluations.map((evaluation) => (
                  <Card key={evaluation._id} className="card">
                    <CardHeader
                      title={
                        <b>
                          {assignmentMap[evaluation.assignment]?.name}
                          {" - Due Date: "}
                          {assignmentMap[evaluation.assignment]?.dueDate
                            ? new Date(
                                assignmentMap[evaluation.assignment].dueDate
                              ).toLocaleDateString()
                            : "No due date"}
                        </b>
                      }
                    ></CardHeader>
                    <CardText>
                      Reviewed Student: {evaluation.nameOfReviewedStudent}
                    </CardText>
                    <CardActions>
                      <FlatButton
                        onClick={() => {
                          const assignment = assignmentMap[evaluation.assignment];
                          props.setAssignment(assignment);
                          props.setSprint(sprintMap[evaluation.sprint]);
                          props.setEvaluation(evaluation);
                          navigate(`/student/evaluation/edit`);
                        }}
                        label="Edit"
                        icon={<ImageEdit />}
                        primary={true}
                      />
                      <FlatButton
                        onClick={() => handleDeleteEvaluation(evaluation)}
                        label="Delete"
                        icon={<ActionDeleteForever />}
                        secondary={true}
                      />
                    </CardActions>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <Dialog
        open={showSuccessMessage}
        onRequestClose={() => setShowSuccessMessage(false)}
      >
        <div>
          <h3>Evaluation deleted successfully</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "20px 10px",
              gap: "24px",
            }}
          >
            <button
              onClick={() => setShowSuccessMessage(false)}
              className="actionButton"
            >
              OK
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog open={showDeleteDialog} onRequestClose={cancelDelete}>
        <div>
          <h3>Are you sure you want to delete this evaluation?</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "20px 10px",
              gap: "24px",
            }}
          >
            <button onClick={cancelDelete} className="actionButton">
              Cancel
            </button>
            <button className="actionButton" onClick={confirmDelete}>
              Delete evaluation
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default connect((state) => state.root, {
  getReviewingStudentEvaluations,
  getSprints,
  getTeacherAssignments,
  deleteEvaluation,
  setLoadingAssets,
  setAssignment,
  setSprint,
  setEvaluation,
})(StudentOverview);
